import { useState, useEffect } from 'react';
import styles from './DataRow.module.scss';
import PropTypes from 'prop-types';
import TextHeader from '../TextHeader/TextHeader';

const DataRow = ({
    percentage,
    header,
    infoLabel,
    infoValue,
    data,
    onDataRowClick,
    isFilteredRow,

    // svg related props
    svgWidth,
    index,
    prevColumn,
    filters
}) => {
    const PANEL_HEIGHT = 46 + 20;
    const MID_BAR = 16 + 5;
    const PROGRESS_BAR_WIDTH = 140;

    const [svgHeight, setSvgHeight] = useState(0);
    const [startY, setStartY] = useState(0);

    useEffect(() => {
        setSvgHeight(PANEL_HEIGHT * (index + 1));
    }, [index]);

    useEffect(() => {
        if (
            prevColumn &&
            prevColumn.productBreakdown &&
            filters &&
            filters.length > 0
        ) {
            const prevColumnName = prevColumn.field;
            const { filterValue } =
                filters.find((f) => f.columnName === prevColumnName) || {};

            if (filterValue) {
                const prevDataRowIndex = prevColumn.productBreakdown.findIndex(
                    (v) => v.dimensionValue === filterValue
                );
                setStartY(PANEL_HEIGHT * prevDataRowIndex);
            }
        }
    }, [prevColumn, filters]);

    const calculateProgress = () => (PROGRESS_BAR_WIDTH / 100) * percentage;

    const getOpacity = (isFilteredRow) => {
        if (isFilteredRow === null) return 1;
        if (isFilteredRow === true) return 1;
        if (isFilteredRow === false) return 0.4;
    };

    const generateArrowPath = (x1, y1, x2, y2, m) => {
        let path;
        const r = m < 30 ? m : 30;
        if (y1 === y2) {
            path = `M${x1},${y1} L${x2},${y2}`;
        } else if (y1 < y2) {
            path = `M${x1},${y1} L${x1 + m - r},${y1} A${r},${r} 0 0 1 ${
                x1 + m
            },${r + y1} L${x1 + m},${y2 - r} A${r},${r} 0 0 0 ${
                m + r
            },${y2} L${x2},${y2}`;
        } else if (y1 > y2) {
            path = `M${x1},${y1} L${x1 + m - r},${y1} A${r},${r} 0 0 0 ${
                x1 + m
            },${y1 - r} L${x1 + m},${y2 + r} A${r},${r} 0 0 1 ${
                m + r
            },${y2} L${x2},${y2}`;
        }
        return (
            <path
                d={path}
                className={styles.arrowPath}
                opacity={getOpacity(isFilteredRow)}
            />
        );
    };

    return (
        <div
            className={styles.wrapper}
            style={{ opacity: getOpacity(isFilteredRow) }}
        >
            {svgWidth && (
                <svg
                    version="1.1"
                    id="rm_pie_chart"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox={`0 0 ${svgWidth} ${
                        svgHeight > startY ? svgHeight : startY + MID_BAR + 1
                    }`}
                    className={styles.svg}
                    width={svgWidth}
                    height={
                        svgHeight > startY ? svgHeight : startY + MID_BAR + 1
                    }
                    style={{
                        left: -1 * svgWidth,
                        top: -1 * PANEL_HEIGHT * index
                    }}
                >
                    {generateArrowPath(
                        0,
                        MID_BAR + startY,
                        svgWidth,
                        svgHeight - PANEL_HEIGHT + MID_BAR,
                        svgWidth / 2
                    )}
                </svg>
            )}

            <TextHeader header={header} />
            <div
                className={styles.progressBar}
                onClick={() =>
                    onDataRowClick({
                        ...data,
                        dimensionValue: header
                    })
                }
            >
                {data.field !== 'rm' && (
                    <div
                        className={styles.percentage}
                        style={{
                            left:
                                percentage >= 90
                                    ? calculateProgress() - 15
                                    : calculateProgress() + 3,
                            color: percentage >= 90 ? '#fff' : null
                        }}
                    >
                        {percentage}%
                    </div>
                )}
                <div
                    className={styles.completed}
                    style={{ width: calculateProgress() }}
                ></div>
            </div>
            <div className={styles.stats}>
                <span className={styles.label}>
                    {infoLabel || 'No.of Trades'} :
                </span>
                <span className={styles.value}>{infoValue}</span>
            </div>
        </div>
    );
};

DataRow.defaultProps = {
    isFilteredRow: null
};

DataRow.propTypes = {
    percentage: PropTypes.number,
    infoLabel: PropTypes.string,
    infoValue: PropTypes.PropTypes.number,
    data: PropTypes.shape(),
    onDataRowClick: PropTypes.func,
    header: PropTypes.string,
    isFilteredRow: PropTypes.bool,
    svgWidth: PropTypes.number,
    index: PropTypes.number,
    prevColumn: PropTypes.shape(),
    filters: PropTypes.arrayOf(PropTypes.shape())
};

export default DataRow;
